import { withProps, createStore, select } from '@ngneat/elf';
import { Actor } from './actor.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const INITIAL_ACTOR: Actor = {
  avatar: null,
  companies: [],
  company: null,
  connection: null,
  email: null,
  hash: null,
  home: null,
  id: null,
  modules: {},
  name: null,
  preferences: [],
  registeredAt: null,
  role: {},
  settings: null,
  type: null,
  workarea: null
};

const actorStore = createStore(
  { name: 'actor' },
  withProps<Actor>(INITIAL_ACTOR)
);

@Injectable({ providedIn: 'root' })
export class ActorStore {

  select(): Observable<Actor> {
    return actorStore.pipe(select((actor) => actor));
  }

  get(): Actor {
    return actorStore.getValue();
  }

  update(actor: Actor): void {
    actorStore.update((state) => ({ ...state, ...actor}));
  }

  reset(): void {
    actorStore.update(() => (INITIAL_ACTOR));
  }
}
